<template>
    <!-- width 390 -->
    <v-layout wrap>
        <!--        <v-navigation-drawer absolute permanent right v-bind:style="{width:500}">-->
        <v-navigation-drawer v-if="!AggregateRulePanelStatus" absolute permanent right :style="panelWidthStyle">
            <!--  상단 이미지 및 선택 타이틀 이름-->
            <v-list class="pa-1">
                <v-list-item>
                    <v-list-item-avatar>
                        <img v-if="value._type == 'org.uengine.modeling.model.Text' || value._type == 'org.uengine.modeling.model.Line'" :src="value.imgSrc">
                        <img v-else :src="img">
                    </v-list-item-avatar>
                    <v-col>
                        <v-list-item-title class="headline">{{ titleName }}</v-list-item-title>
                        <div v-if="elementAuthorDisplay"
                            class="gs-model-panel-Author">
                            Author : {{elementAuthorDisplay}}
                        </div>
                    </v-col>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click.native="closePanel()">
                                <v-icon color="grey lighten-1">mdi-close</v-icon>
                            </v-btn>
                            <v-btn icon v-on="on">
                                <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ getDescriptionText }}</span>
                    </v-tooltip>
                </v-list-item>
            </v-list>


            <!--  해당 판넬의 내용  -->
            <v-list class="pt-0" dense flat>

                <v-divider></v-divider>
                <v-card outlined>
                    <v-card-text v-if="value._type != 'org.uengine.modeling.model.Text' && value._type != 'org.uengine.modeling.model.Line'">
                        <div style="color: skyblue" v-if="isShowError">Notice: {{showError}}</div>
                        <span class="headline">Basic Info</span>
                        <v-btn 
                            v-if="copyValue._type == 'org.uengine.modeling.model.Aggregate'" 
                            color="primary" 
                            text 
                            style="margin-left: 10px; margin-top: -12px;"
                            @click="changeAggregateRulePanelStatus()"
                        >Rules</v-btn>
                        <div>
                            <v-text-field
                                    v-model="namePanel"
                                    :error="namePanel == ''"
                                    id="elementName"
                                    :disabled="isReadOnly"
                                    label="Name"
                                    autofocus
                            >
                            </v-text-field>
                            <v-card style="margin-bottom: 10px;" outlined v-if="usedTranslate" :disabled="isReadOnly">
                                <v-card-text id="suggested-words" @click="changeTranslate()">
                                    {{$t('word.recommendWord')}} : {{ translateText }}
                                </v-card-text>
                                <v-card-text>
                                    {{$t('word.recommendWordDetail')}}
                                </v-card-text>
                            </v-card>
                            <v-textarea
                                    v-if="!copyValue._type.endsWith('Relation')"
                                    v-model="descriptionPanel"
                                    label="Description"
                                    :disabled="isReadOnly"
                            ></v-textarea>
                        </div>

                        <div v-if="copyValue._type == 'org.uengine.modeling.model.BoundedContext'">
                            <v-autocomplete
                                    v-if="selectedTemplateLists"
                                    v-model="copyValue.preferredPlatform"
                                    :items="selectedTemplateLists"
                                    item-text="display"
                                    item-value="template"
                                    :disabled="isReadOnly"
                                    label="Preferred Platform"
                            ></v-autocomplete>
                        </div>
                        <div v-if="copyValue._type == 'org.uengine.modeling.model.BoundedContext'">
                            <v-autocomplete
                                    v-model="copyValue.members"
                                    :items="userLists"
                                    filled
                                    chips
                                    color="blue-grey lighten-2"
                                    label="Select"
                                    item-text="userName"
                                    return-object
                                    :multiple="true"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            close
                                            @click="data.select"
                                            @click:close="remove(data.item)"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.userPic"></v-img>
                                        </v-avatar>
                                        {{ data.item.userName }}
                                    </v-chip>
                                </template>
                                <!-- <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.userPic">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="data.item.userName"></v-list-item-title>
                                            <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template> -->
                            </v-autocomplete>
                        </div>
                        <div v-if="copyValue._type == 'org.uengine.modeling.model.BoundedContext' && value.members">
                            <template>
                                <div>
                                    <v-data-table
                                            :headers="userTableHeaders"
                                            :items="copyValue.members"
                                            class="elevation-1"
                                    >
                                        <template v-slot:item.readable="{ item }">
                                            <v-simple-checkbox
                                                    v-model="item.readable"
                                                    :ripple="false"
                                            ></v-simple-checkbox>
                                        </template>
                                        <template v-slot:item.writable="{ item }">
                                            <v-simple-checkbox
                                                    v-model="item.writable"
                                                    :ripple="false"
                                            ></v-simple-checkbox>
                                        </template>
                                        <template v-slot:item.admin="{ item }">
                                            <v-simple-checkbox
                                                    v-model="item.admin"
                                                    :ripple="false"
                                            ></v-simple-checkbox>
                                        </template>
                                    </v-data-table>
                                </div>
                            </template>
                        </div>

                        <span class="headline"
                              v-if="copyValue._type == 'org.uengine.modeling.model.Event' ||
                              copyValue._type == 'org.uengine.modeling.model.Aggregate'">Examples</span>
                            <div>
                                <v-textarea
                                    v-if="!copyValue._type.endsWith('Relation')"
                                    v-model="examplesPanel"
                                    label="Examples"
                                    :disabled="isReadOnly"
                                ></v-textarea>
                            </div>

                        <event-storming-attribute
                                v-if="copyValue._type == 'org.uengine.modeling.model.Event'"
                                v-model="copyValue.fieldDescriptors"
                                :isReadOnly="isReadOnly"
                                :type="copyValue._type"
                                :elementId="copyValue.elementView.id"
                                @sync-attribute="syncFromAggregate"
                        ></event-storming-attribute>

                        <div v-if="copyValue._type == 'org.uengine.modeling.model.Event'">
                            <span class="headline">Trigger</span>
                            <v-layout v-if="copyValue._type == 'org.uengine.modeling.model.Event'" flat>
                                <v-radio-group v-model="copyValue.trigger" style="width: 290px;" :disabled="isReadOnly">
                                    <v-row dense>
                                        <v-col dense>
                                            <v-radio style="width: 110px" label="Pre Persist"
                                                     value="@PrePersist"></v-radio>
                                            <v-radio label="Pre Update" value="@PreUpdate"></v-radio>
                                            <v-radio label="Pre Remove" value="@PreRemove"></v-radio>
                                        </v-col>
                                        <v-col dense>
                                            <v-radio label="Post Persist" value="@PostPersist"></v-radio>
                                            <v-radio label="Post Update" value="@PostUpdate"></v-radio>
                                            <v-radio style="width: 130px" label="Post Remove"
                                                     value="@PostRemove"></v-radio>
                                        </v-col>
                                    </v-row>
                                </v-radio-group>
                            </v-layout>
                        </div>
                        <div v-if="copyValue._type == 'org.uengine.modeling.model.Event'">
                            <span class="headline">Trigger Command</span>
                            <v-layout v-if="copyValue._type == 'org.uengine.modeling.model.Event'" flat>
                                <v-autocomplete
                                        v-model="copyValue.trigger.command"
                                        :items="commandLists"
                                        :disabled="isReadOnly"
                                        label="Commands" persistent-hint>
                                </v-autocomplete>
                            </v-layout>
                        </div>
                        
                        <event-storming-attribute
                                v-else-if="copyValue._type == 'org.uengine.modeling.model.Aggregate'"
                                v-model="copyValue.aggregateRoot.fieldDescriptors"
                                :isReadOnly="isReadOnly"
                                :type="copyValue._type"
                                :elementId="copyValue.elementView.id"
                                @open-umlclass="openClassDiagram"
                        ></event-storming-attribute>

                        <span class="headline"
                              v-if="copyValue._type == 'org.uengine.modeling.model.Event' "
                        >
                            Associated Aggregate</span>
                        <v-layout
                                v-if="copyValue._type == 'org.uengine.modeling.model.Event' "
                                flat>
                            <v-text-field
                                    v-model="copyValue.aggregate.name"
                                    label="Attach Aggregate && check Name"
                                    single-line
                                    disabled
                            ></v-text-field>
                        </v-layout>

                        <v-layout v-if="copyValue._type == 'org.uengine.modeling.model.Command'">
                            <v-col>
                                <v-radio-group v-model="copyValue.isRestRepository" :disabled="isReadOnly"
                                               style="margin-left:-13px;" row>
                                    <v-radio label="RestRepository" :value="true"></v-radio>
                                    <v-radio label="Controller" :value="false"></v-radio>
                                </v-radio-group>
                                <span class="headline" style="margin-left:-10px;">Associated Aggregate</span>
                                <v-text-field
                                        v-model="copyValue.aggregate.name"
                                        label="Attach Aggregate && check Name"
                                        single-line
                                        disabled
                                        style="margin-left:-10px; margin-top:-15px; min-width:105%;"
                                ></v-text-field>


                                <v-col v-if="copyValue.isRestRepository">
                                    <v-autocomplete
                                            :disabled="isReadOnly"
                                            v-model="copyValue.restRepositoryInfo.method"
                                            :items="restfulList"
                                            style="margin-left: -22px; min-width:111%;"
                                            label="Method" persistent-hint>
                                    </v-autocomplete>
                                </v-col>

                                <v-col v-else>
                                    <div style="margin-left:-22px;">Api path</div>
                                    <v-text-field
                                            v-model="copyValue.controllerInfo.apiPath"
                                            outlined
                                            :disabled="isReadOnly"
                                            style="margin-left: -22px; min-width:111%;"
                                            hint="맨 처음 '/' 제외한 apiPath를 작성해주세요. (Default '/')"
                                    ></v-text-field>
                                    <v-autocomplete
                                            v-model="copyValue.controllerInfo.method"
                                            :items="restfulList"
                                            style="margin-left: -22px; min-width:111%;"
                                            :disabled="isReadOnly"
                                            label="Method" persistent-hint>
                                    </v-autocomplete>
                                </v-col>
                            </v-col>

                        </v-layout>

                        <v-layout v-if="copyValue._type == 'org.uengine.modeling.model.External'">
                            <v-col>
                                <div style="margin-left:-22px;">Api path</div>
                                <v-text-field
                                        v-model="copyValue.controllerInfo.apiPath"
                                        outlined
                                        :disabled="isReadOnly"
                                        hint="맨 처음 '/' 제외한 apiPath를 작성해주세요. (Default '/')"
                                ></v-text-field>
                                <div>Method</div>
                                <v-autocomplete
                                        v-model="copyValue.controllerInfo.method"
                                        :items="restfulList"
                                        style="margin-left: 10px; margin-right: 10px;"
                                        :disabled="isReadOnly"
                                        label="Method" persistent-hint>
                                </v-autocomplete>
                            </v-col>

                        </v-layout>

                        <event-storming-attribute
                                v-else-if="copyValue._type == 'org.uengine.modeling.model.View'"
                                v-model="copyValue.fieldDescriptors"
                                :isReadOnly="isReadOnly"
                                :type="copyValue._type"
                                :elementId="copyValue.elementView.id"
                        ></event-storming-attribute>

                        <v-layout
                                v-if="value._type == 'org.uengine.modeling.model.View'"
                                style="width: auto; width:480px; margin-left:-15px;"
                        >
                            <v-card-text>
                                <!-- <span class="headline">Attributes</span>
                                <v-data-table
                                        :headers="headers"
                                        :items="copyValue.fieldDescriptors"
                                        hide-default-header
                                        hide-default-footer
                                        :items-per-page="100"
                                        class="elevation-1"
                                        :disabled="isReadOnly"
                                >

                                    <template v-slot:item.isKey="{ item }">
                                        <v-icon v-if="item.isKey" small disabled @click="selectKey(item)"> mdi-key
                                        </v-icon>
                                        <v-icon v-else small @click="selectKey(item)" :disabled="isReadOnly">
                                            mdi-checkbox-blank-circle-outline
                                        </v-icon>
                                    </template>

                                    <template v-slot:item.className="{ item }">
                                        <div v-if="!attributeEdit || copyValue.fieldDescriptors.indexOf(item) != attributeEditIndex">
                                            {{item.className}}
                                        </div>
                                        <v-select
                                                v-else-if="attributeEdit && copyValue.fieldDescriptors.indexOf(item) == attributeEditIndex "
                                                v-model="item.className" :items="entityTypeList"></v-select>
                                    </template>

                                    <template v-slot:item.name="{ item }">
                                        <div v-if="!attributeEdit || copyValue.fieldDescriptors.indexOf(item) != attributeEditIndex">
                                            {{item.name}}
                                        </div>
                                        <v-text-field
                                                v-else-if="attributeEdit && copyValue.fieldDescriptors.indexOf(item) == attributeEditIndex "
                                                v-model="item.name" required></v-text-field>
                                    </template>


                                    <template v-slot:item.action="{ item }">
                                        <v-icon
                                                v-if="attributeEdit && copyValue.fieldDescriptors.indexOf(item) == attributeEditIndex"
                                                small
                                                class="mr-2"
                                                @click="modifyAttributeItem(item)"
                                        >
                                            mdi-content-save
                                        </v-icon>
                                        <v-icon
                                                v-else-if="!attributeEdit || copyValue.fieldDescriptors.indexOf(item) != attributeEditIndex"
                                                small
                                                class="mr-2"
                                                :disabled="isReadOnly"
                                                @click="editAttributeItem(item)"
                                        >
                                            edit
                                        </v-icon>
                                        <v-icon
                                                v-if="!item.isKey"
                                                small
                                                :disabled="isReadOnly"
                                                @click="deleteAttribute(item)"
                                        >
                                            delete
                                        </v-icon>
                                    </template>
                                </v-data-table>


                                <v-row justify="center" style="width:450px; margin-left:0px;">
                                    <v-select style="width: 30px" v-model="entityType" :items="entityTypeList"
                                              :disabled="isReadOnly"
                                              label="Type"></v-select>
                                    <v-text-field v-model="entityName" label="Name"
                                                  v-on:keyup.enter="addAttribute(entityType,entityName)"
                                                  :disabled="isReadOnly"
                                                  required></v-text-field>
                                </v-row>
                                <v-row justify="end">
                                    <v-btn style="margin-bottom:10px; margin-right:10px;"
                                           :disabled="isReadOnly"
                                           color="primary" @click="addAttribute(entityType,entityName)"
                                           dark>
                                        ADD ATTRIBUTE
                                    </v-btn>
                                </v-row> -->


                                <v-radio-group :disabled="isReadOnly"
                                               v-model="copyValue.dataProjection" row>
                                    <v-radio :disabled="isOnlyCQRS" label="CQRS" value="cqrs"></v-radio>
                                    <v-radio label="UI Mashup" value="uimashup"></v-radio>
                                    <v-radio disabled label="GraphQL" value="graphql"></v-radio>
                                </v-radio-group>


                                <div v-if="copyValue.dataProjection == 'cqrs'">
                                    <v-col v-for="(item,key) in copyValue.createRules">
                                        <ViewCreate
                                                v-model="copyValue"
                                                :createItem="item"
                                                :index="key"
                                                :isRead="isReadOnly"
                                        ></ViewCreate>
                                    </v-col>
                                    <v-row align="start" justify="end">
                                        <v-btn text
                                               :disabled="isReadOnly"
                                               @click="viewMainRowAdd('create')">
                                            <v-icon class="outlined"> mdi-plus</v-icon>
                                        </v-btn>
                                    </v-row>

                                    <v-col v-for="(item,key) in copyValue.updateRules">
                                        <ViewUpdate
                                                v-model="copyValue"
                                                :updateItem="item"
                                                :index="key"
                                                :isRead="isReadOnly"
                                        >
                                        </ViewUpdate>
                                    </v-col>
                                    <v-row align="center" justify="end">
                                        <v-btn text
                                               :disabled="isReadOnly"
                                               @click="viewMainRowAdd('update')">
                                            <v-icon class="outlined"> mdi-plus</v-icon>
                                        </v-btn>
                                    </v-row>

                                    <v-col v-for="(item,key) in copyValue.deleteRules">
                                        <ViewDelete
                                                v-model="copyValue"
                                                :deleteItem="item"
                                                :index="key"
                                                :isRead="isReadOnly"
                                        ></ViewDelete>
                                    </v-col>
                                    <v-row align="start" justify="end">
                                        <v-btn text :disabled="isReadOnly"
                                               @click="viewMainRowAdd('delete')">
                                            <v-icon class="outlined"> mdi-plus</v-icon>
                                        </v-btn>
                                    </v-row>
                                </div>


                            </v-card-text>
                        </v-layout>

                        <span class="headline"
                              v-if="copyValue._type == 'org.uengine.modeling.model.Relation' && copyValue.circuitBreaker != undefined"
                        >
                            Associated Aggregate</span>
                        <v-layout
                                v-if="(copyValue._type == 'org.uengine.modeling.model.Relation') && copyValue.circuitBreaker != undefined"
                                flat>
                            <v-col>

                                <v-switch
                                        v-model="copyValue.circuitBreaker"
                                        inset
                                        :label="`Circuit Breaker`"
                                ></v-switch>
                                <v-checkbox
                                        v-if="copyValue.circuitBreaker"
                                        v-model="copyValue.fallback"
                                        :label="`Fallback`"
                                ></v-checkbox>
                            </v-col>
                        </v-layout>
                    </v-card-text>

                    <v-card-text v-if="copyValue._type == 'org.uengine.modeling.model.Text'">
                        <div style="color: skyblue" v-if="isShowError">Notice: {{showError}}</div>
                        <v-text-field
                                v-model="namePanel"
                                :error="namePanel == ''"
                                :disabled="isReadOnly"
                                label="Name"
                                autofocus
                        ></v-text-field>
                        <div class="my-5">
                            <v-label>Size</v-label>
                            <div style="display: flex;">
                                <v-btn 
                                        class="mx-1 my-2" text 
                                        style="font-size: 20px" 
                                        @click="resizedText(20)"
                                >Text</v-btn>
                                <v-btn 
                                        class="mx-1 my-2" text 
                                        style="font-size: 40px" 
                                        @click="resizedText(40)"
                                >Text</v-btn>
                                <v-btn 
                                        class="mx-1 my-2" text 
                                        style="font-size: 60px" 
                                        @click="resizedText(60)"
                                >Text</v-btn>
                            </div>
                        </div>
                    </v-card-text>

                    <v-card-text v-if="copyValue._type == 'org.uengine.modeling.model.Line'">
                        <v-label>Color</v-label>
                        <div style="display: flex;">
                            <div v-for="(color, idx) in colorList" :key="idx">
                                <v-btn  v-if="copyValue.color == color && (copyValue.color == '#F1A746' || copyValue.color == '#5099F7' || copyValue.color == '#BB94BF' || copyValue.color == '#F8D454' || copyValue.color == '#ED73B6')" 
                                        class="my-2 mx-2" 
                                        fab x-small 
                                        depressed
                                        :color="color"
                                        @click="changeColor(color)"
                                >
                                    <v-icon>mdi-check-bold</v-icon>
                                </v-btn>
                                <v-btn  v-else-if="copyValue.color == color && (copyValue.color == '#000000' || copyValue.color == '#9E9E9E' || copyValue.color == '#5FC08B' || copyValue.color == '#8E24AA')" 
                                        class="my-2 mx-2" 
                                        fab x-small 
                                        depressed dark
                                        :color="color"
                                        @click="changeColor(color)"
                                >
                                    <v-icon dark>mdi-check-bold</v-icon>
                                </v-btn>
                                <v-btn  v-else 
                                        class="my-2 mx-2" 
                                        fab x-small
                                        depressed 
                                        :color="color"
                                        @click="changeColor(color)"
                                ></v-btn>
                            </div>
                        </div>
                        <div class="my-5">
                            <v-label>Size</v-label>
                            <div style="display: flex;">
                                <v-btn  class="mx-1 my-2" 
                                        depressed tile
                                        color="#212121"
                                        style="width: 100px; height: 5px;"
                                        @click="resizedEdge(5)"
                                ></v-btn>
                                <v-btn  class="mx-1 my-2" 
                                        depressed tile
                                        color="#212121"
                                        style="width: 100px; height: 10px;"
                                        @click="resizedEdge(10)"
                                ></v-btn>
                                <v-btn  class="mx-1 my-2" 
                                        depressed tile
                                        color="#212121"
                                        style="width: 100px; height: 15px;"
                                        @click="resizedEdge(15)"
                                ></v-btn>
                                <v-btn  class="mx-1 my-2"
                                        depressed tile
                                        color="#212121"
                                        style="width: 100px; height: 20px;"
                                        @click="resizedEdge(20)"
                                ></v-btn>
                            </div>
                        </div>
                        <div class="my-5">
                            <v-label>Style</v-label>
                            <div style="display: flex;">
                                <v-btn  class="mx-1 my-2"
                                        depressed text 
                                        style="color:black;"
                                        @click="changeDashStyle('')"
                                >Solid</v-btn>
                                <v-btn  class="mx-1 my-2" 
                                        depressed text 
                                        style="color:black;"
                                        @click="changeDashStyle('.')"
                                >Dotted</v-btn>
                                <v-btn  class="mx-1 my-2" 
                                        depressed text 
                                        style="color:black;"
                                        @click="changeDashStyle('- ')"
                                >Dashed</v-btn>
                                <v-btn  class="mx-1 my-2" 
                                        depressed text 
                                        style="color:black;"
                                        @click="changeDashStyle('--')"
                                >Long Dashed</v-btn>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-list>
            
        </v-navigation-drawer>
        <v-navigation-drawer v-else absolute permanent right :style="panelWidthStyle">
            <div style="width: 100%;">
                <v-btn icon @click.native="changeAggregateRulePanelStatus()">
                    <v-icon color="grey lighten-1">mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn style="float: right;" icon @click.native="closePanel()">
                    <v-icon color="grey lighten-1">mdi-close</v-icon>
                </v-btn>
            </div>
            <v-divider />
            <v-card v-for="(rule, idx) in copyValue.aggregateRules" :key="idx" style="margin-bottom: 15px;">
                <v-card-title>
                    <div style="width: 100%;">
                        <span v-if="rule.editMode">
                            <v-text-field 
                                @keydown.enter="rule.editMode = false" 
                                @keydown.esc="rule.editMode = false"
                                @click:append-outer="rule.editMode = false"
                                v-model="rule.ruleName"
                                :rules="[ruleRequired]"
                                label="Rule Name" 
                                append-outer-icon="mdi-content-save"
                            ></v-text-field>
                        </span>
                        <span v-else @click="rule.editMode = true">
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-if="rule.ruleName" v-bind="attrs" v-on="on">
                                        {{ rule.ruleName }}
                                    </span>
                                    <span v-else v-bind="attrs" v-on="on">
                                        Rule {{ idx + 1 }}  
                                    </span>
                                </template>
                                <span>Click to Edit</span>
                            </v-tooltip>
                            <v-btn style="float: right; margin: -15px;" icon @click.native="deleteAggregateRule(idx)">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </span>
                    </div>
                </v-card-title>
                <div style="margin: 15px;">
                    <v-autocomplete
                        v-model="rule.givenValue"
                        :items="givenItems"
                        @change="resetRules(rule)"
                        item-text="name"
                        dense
                        return-object
                        label="Given"
                    ></v-autocomplete>
                    <v-autocomplete
                        v-model="rule.whenValue"
                        :items="rule.whenItems"
                        @click.native="chooseWhenPolicy(idx)"
                        item-text="name"
                        dense
                        return-object
                        label="When"
                    ></v-autocomplete>
                    <v-autocomplete
                        v-model="rule.thenValue"
                        :items="rule.thenItems"
                        item-text="name"
                        @click.native="chooseThenEvent(idx)"
                        dense
                        return-object
                        label="Then"
                    ></v-autocomplete>
                </div>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="rule.givenValue"
                        color="primary"
                        text
                        small
                        @click="openExampleDialog(rule)"
                    >
                        Examples
                    </v-btn>
                </v-card-actions>

                <v-dialog v-model="rule.show" @click:outside="resetAttribute(rule, 'save')" width="100%">
                    <v-card>
                        <v-card-title>
                            <span v-if="rule.ruleName">{{ rule.ruleName }}/Examples</span>
                            <span v-else>Rule {{ idx + 1 }}/Examples</span>                        
                        </v-card-title>
                        <v-divider></v-divider>
                        <span style="width: 100%; display: flex; height: 600px; overflow-y:scroll;">
                            <ag-grid-vue
                                style="width: 50%;"
                                class="ag-theme-alpine"
                                :columnDefs="givenColumnDefs"
                                :rowData="givenRowData"
                                :defaultColDef="defaultColDef"
                                rowSelection="single"
                                @row-selected="onRowSelected"
                                @grid-ready="onGridReady"
                                :enableRangeSelection="false"
                                :enableFillHandle="false"
                                :undoRedoCellEditing="true"
                                :undoRedoCellEditingLimit="30"
                                :enableCellChangeFlash="true"
                                domLayout="autoHeight"
                            >
                            </ag-grid-vue>
                            <ag-grid-vue
                                style="width: 50%;"
                                class="ag-theme-alpine"
                                :columnDefs="thenColumnDefs"
                                :rowData="thenRowData"
                                :defaultColDef="defaultColDef"
                                rowSelection="single"
                                @row-selected="onRowSelected"
                                @grid-ready="onGridReady"
                                :enableRangeSelection="false"
                                :enableFillHandle="false"
                                :undoRedoCellEditing="true"
                                :undoRedoCellEditingLimit="30"
                                :enableCellChangeFlash="true"
                                domLayout="autoHeight"
                            >
                            </ag-grid-vue>
                        </span>
                        <v-divider></v-divider>
                        <div style="background-color: white; width: 100%;">
                            <v-tooltip right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-if="rule.givenValue" icon @click.native="addAggregateRuleAttribute(rule)" v-bind="attrs" v-on="on">
                                        <v-icon color="grey lighten-1">mdi-plus</v-icon>
                                    </v-btn>
                                </template>
                                <span>Add New Example</span>
                            </v-tooltip>
                            <v-btn v-if="rowIndex!=null" icon @click.native="deleteAggregateRuleAttribute(rule)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                            <v-btn text color="primary" style="float: right; margin-right: 10px;" @click.native="resetAttribute(rule, 'save')">
                                Save
                            </v-btn>
                        </div>
                    </v-card>
                </v-dialog>
            </v-card>


            <div style="width: 100%; margin-bottom: 15px;">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click.native="addAggregateRule()" v-bind="attrs" v-on="on">
                            <v-icon color="grey lighten-1">mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>Add New Rule</span>
                </v-tooltip>
                <!-- <div style="float: right; text-align: right; margin-right: 10px;">
                    <v-btn color="primary" @click.native="saveRules()">Save</v-btn>
                </div> -->
            </div>
        </v-navigation-drawer>
    </v-layout>
</template>

<script>
    import ModelPanel from "../modeling/ModelPanel";

    var _ = require('lodash')
    var googleTranslate = require('google-translate')(process.env.VUE_APP_TRANSLATE_KEY);
    var changeCase = require('change-case');
    var pluralize = require('pluralize');
    import draggable from 'vuedraggable'

    import "ag-grid-community/dist/styles/ag-grid.css";
    import "ag-grid-community/dist/styles/ag-theme-alpine.css";
    import { AgGridVue } from "ag-grid-vue";


    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    export default {
        name: 'event-storming-model-panel-origin',
        mixins: [ModelPanel],
        props: {
            showError: {
                type: String,
                default: function () {
                    return null
                }
            },
            widthStyle: {
                type: String,
                default: function () {
                    return 'width: 500px;'
                }
            },
        },
        components: {
            draggable,
            AgGridVue
        },
        computed: {
            isOnlyCQRS() {
                try {
                    var me = this
                    if (me.canvasbase.value && me.canvasbase.value.relations) {
                        var index = Object.values(me.canvasbase.value.relations).findIndex(relation => relation && relation.from == me.value.elementView.id)
                        if (index == -1) {
                            return false
                        } else {
                            return true
                        }
                    }
                    return false
                } catch (e) {
                    return false
                }
            },
            userLists() {
                var me = this;
                var result = [];
                if (me.canvasbase.information) {
                    if (me.value._type == 'org.uengine.modeling.model.BoundedContext') {
                        if (me.canvasbase.information.permissions) {
                            var arr = Object.keys(me.canvasbase.information.permissions);

                            for (var key in arr) {
                                result.push(me.canvasbase.information.permissions[arr[key]]);
                            }
                        }

                    }
                }
                return result;
            },
            selectedTemplateLists() {
                var me = this
                var list = null
                if (me.canvasbase && me.canvasbase.templateList) {
                    if (!list) list = []
                    list = JSON.parse(JSON.stringify(me.canvasbase.templateList))
                    list.shift()
                    return list
                }
                return list
            },
            isShowError() {
                return this.showError
            },
            elementAuthorDisplay() {
                var me = this
                var str = null
                if (me.canvasbase && me.canvasbase.information) {
                    if (me.value.author && me.canvasbase.information.author) {

                        if (me.value.author == me.canvasbase.information.author) {
                            str = me.canvasbase.information.authorEmail
                        } else if (me.canvasbase.information.permissions) {
                            var userInfo = me.canvasbase.information.permissions[me.value.author]
                            if (userInfo) {
                                str = userInfo.userName
                            } else {
                                str = '권한 없는 유저'
                            }
                        } else {
                            str = null
                        }
                        return str;
                    }
                }
                return str;

            },
            panelWidthStyle() {
                return this.widthStyle
            },
            titleName() {
                var me = this
                if (me.value._type.split('.')[4] == 'View') {
                    return 'ReadModel'
                }
                if (me.value._type.includes('Line')) {
                    return 'Line'
                }
                return me.value._type.split('.')[4]
            },
            getDescriptionText() {
                var me = this
                if (me.value._type == 'org.uengine.modeling.model.Event') {
                    return '도메인 전문가가 정의함. 이벤트 퍼블리싱'
                } else if (me.value._type == 'org.uengine.modeling.model.Aggregate') {
                    return '비즈니스 로직 처리의 도메인 객체 덩어리 (서로 연결된 하나 이상의 엔터티 및 value objects의 집합체)'
                } else if (me.value._type == 'org.uengine.modeling.model.Command') {
                    return '행동, 결정 등의 값들에 대한 정의 (UI 혹은 API)'
                } else if (me.value._type == 'org.uengine.modeling.model.External') {
                    return '외부 시스템'
                } else if (me.value._type == 'org.uengine.modeling.model.Policy') {
                    return '업무정책 이벤트에 대한 반응 (subscribe)'
                } else if (me.value._type == 'org.uengine.modeling.model.View') {
                    return '행위와 결정을 하기 위하여 유저가 참고하는 데이터 (데이터 프로젝션이 필요 :  CQRS 등으로 수집)'
                } else if (me.value._type == 'org.uengine.modeling.model.BoundedContext') {
                    return '이벤트의 내용을 정의하고 시스템의 경계를 구분.'
                } else if (me.value._type == 'org.uengine.modeling.model.Actor') {
                    return ''
                }

                return ''
            },
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            umlClass() {
                var data
                if(localStorage['umlClass']) {
                    data = localStorage.getItem('umlClass')
                    console.log(data)
                }
                return data
            },
        },
        beforeDestroy() {
            var me = this

            if (me.copyValue.fieldDescriptors) {
                for (var i = 0; i < me.copyValue.fieldDescriptors.length; i++) {
                    if (me.copyValue.fieldDescriptors[i].name != me.copyValue.fieldDescriptors[i].nameCamelCase) {
                        me.copyValue.fieldDescriptors[i].nameCamelCase = me.copyValue.fieldDescriptors[i].name
                    }
                    if (me.copyValue.fieldDescriptors[i].name != me.copyValue.fieldDescriptors[i].namePascalCase) {
                        me.copyValue.fieldDescriptors[i].namePascalCase = me.copyValue.fieldDescriptors[i].name
                    }
                }
            }

            var diff = jsondiffpatch.diff(me.value, me.copyValue)
            console.log('diff')
            console.log(diff)
            if (diff && !(Object.keys(diff).includes('aggregate') && Object.keys(diff).length == 1)) {
                if (!me.isReadOnly) {
                    me.canvasbase.changedByMe = true

                    // Common setting
                    if (me.namePanel != me.copyValue.name) {
                        me.copyValue.name = me.namePanel
                    }
                    me.value.name = me.copyValue.name

                    // Only Sticker setting
                    if (!me.value._type.endsWith('Relation')) {
                        if (me.descriptionPanel != me.copyValue.description) {
                            me.copyValue.description = me.descriptionPanel
                        }
                        if (me.examplesPanel != me.copyValue.examples){
                            me.copyValue.examples = me.examplesPanel
                        }
                        me.value.description = me.copyValue.description
                        me.value.examples = me.copyValue.examples
                        me.value.aggregateRules = me.copyValue.aggregateRules
                    }

                    
                    //Individual
                    if (me.value._type == 'org.uengine.modeling.model.Aggregate') {
                        me.value.aggregateRoot = me.copyValue.aggregateRoot
                        me.value.aggregateRules = me.copyValue.aggregateRules
                    } else if (me.value._type == 'org.uengine.modeling.model.Command') {
                        me.value.isRestRepository = me.copyValue.isRestRepository
                        me.value.controllerInfo = me.copyValue.controllerInfo
                        me.value.restRepositoryInfo = me.copyValue.restRepositoryInfo
                    } else if (me.value._type == 'org.uengine.modeling.model.Event') {
                        me.value.trigger = me.copyValue.trigger
                        me.value.fieldDescriptors = me.copyValue.fieldDescriptors
                    } else if (me.value._type == 'org.uengine.modeling.model.View') {
                        me.value.fieldDescriptors = me.copyValue.fieldDescriptors
                        me.value.dataProjection = me.copyValue.dataProjection
                        me.value.createRules = me.copyValue.createRules
                        me.value.updateRules = me.copyValue.updateRules
                        me.value.deleteRules = me.copyValue.deleteRules
                    } else if (me.value._type == 'org.uengine.modeling.model.Policy') {

                    } else if (me.value._type == 'org.uengine.modeling.model.BoundedContext') {
                        me.value.preferredPlatform = me.copyValue.preferredPlatform
                        me.value.members = me.copyValue.members
                    } else if (me.value._type == 'org.uengine.modeling.model.Actor') {
                    } else if (me.value._type == 'org.uengine.modeling.model.External') {
                        me.value.controllerInfo = me.copyValue.controllerInfo
                    } else if (me.value._type == 'org.uengine.modeling.model.Issue') {
                    } else if (me.value._type == 'org.uengine.modeling.model.Relation') {
                        console.log(me.copyValue.fallback, me.copyValue.circuitBreaker)
                        if (me.copyValue.circuitBreaker != undefined) {
                            me.value.circuitBreaker = me.copyValue.circuitBreaker
                        }

                        if (me.copyValue.fallback != undefined) {
                            me.value.fallback = me.copyValue.fallback
                        }

                    } else if (me.value._type == 'org.uengine.modeling.model.Text') {
                        me.value.fontSize = me.copyValue.fontSize
                    } else if (me.value._type == 'org.uengine.modeling.model.Line') {
                        me.value.color = me.copyValue.color
                        me.value.size = me.copyValue.size
                        me.value.dashStyle = me.copyValue.dashStyle
                    }

                    console.log("before Destroy 1")
                    console.log(me.value.aggregateRules)
                } else {
                    // ReadOnly
                }
            } else {
                if (me.value._type.endsWith('Relation')) {
                    if (me.namePanel != me.copyValue.name) {
                        if (!me.isReadOnly) {
                            me.canvasbase.changedByMe = true
                            me.value.name = me.namePanel
                        }
                    }
                } else {
                    
                    if (me.namePanel != me.copyValue.name || me.descriptionPanel != me.copyValue.description) {
                        if (!me.isReadOnly) {
                            me.canvasbase.changedByMe = true
                            me.value.name = me.namePanel
                            me.value.description = me.descriptionPanel
                        }
                    }
                    if (me.namePanel != me.copyValue.name || me.examplesPanel != me.copyValue.examples || me.aggregateRules != me.copyValue.aggregateRules) {
                        if (!me.isReadOnly) {
                            
                            me.canvasbase.changedByMe = true
                            me.value.name = me.namePanel
                            me.value.examples = me.examplesPanel
                            me.value.aggregateRules = me.copyValue.aggregateRules
                        }
                    }
                }


                // if (me.value._type == 'org.uengine.modeling.model.Issue' || me.value._type == 'org.uengine.modeling.model.Policy' || me.value._type == 'org.uengine.modeling.model.View') {
                //     if (me.namePanel != me.copyValue.name || me.descriptionPanel != me.copyValue.description) {
                //         if (!me.isReadOnly) {
                //             me.canvasbase.changedByMe = true
                //             me.value.name = me.namePanel
                //             me.value.description = me.descriptionPanel
                //         }
                //     }
                // } else {
                //     if (me.namePanel != me.copyValue.name) {
                //         if (!me.isReadOnly) {
                //             me.canvasbase.changedByMe = true
                //             me.value.name = me.namePanel
                //         }
                //     }
                // }
            }

            if (me.canvasbase.isServerModeling
                && me.canvasbase.isQueueModeling
                && !me.canvasbase.isClazzModeling
                && !me.canvasbase.isReadModeling
                && !me.canvasbase.isHexagonal
            ) {
                me.panelCloseQueue()
            }

            // this.value.__ob__.dep.notify();
        },
        created: function () {
            var me = this
            me.canvasbase = me.$parent.getComponent('event-storming-model-canvas')

            //init setting
            me.namePanel = me.value.name

            // only sticker
            if (!me.value._type.endsWith('Relation')) {
                me.descriptionPanel = me.value.description
            }

            if (!me.value._type.endsWith('Relation')) {
                me.examplesPanel = me.value.examples
            }


            if (me.copyValue._type == 'org.uengine.modeling.model.Event' ||
                me.copyValue._type == 'org.uengine.modeling.model.Command') {
                me.findAssociatedAggregate()
            }
            if (me.copyValue._type == 'org.uengine.modeling.model.Event') {

                me.findCommandLists();
            }

            if (me.copyValue._type == 'org.uengine.modeling.model.Aggregate') {
                
                me.setEntityTypeList()
            }


            if (me.canvasbase.isServerModeling
                && me.canvasbase.isQueueModeling
                && !me.canvasbase.isClazzModeling
                && !me.canvasbase.isReadModeling
                && !me.canvasbase.isHexagonal
            ) {
                me.panelOpenQueue()
            }

            if (me.copyValue._type == 'org.uengine.modeling.model.Aggregate') {
                var umlClass = new BroadcastChannel('umlCanvas')
                umlClass.onmessage = res => {
                    var entities = JSON.parse(res.data)
                    me.addAggregateRoot(entities)
                }
            }

        },
        data: function () {
            return {
                ruleRequired: value => !!value || 'Required.',
                // Example table
                gridApi: null,
                defaultColDef: {
                    editable: true,
                    resizable: true,
                },
                givenColumnDefs: [],
                givenRowData: [],

                thenColumnDefs: [],
                thenRowData: [],

                rowIndex: null,

                givenName: null,
                aggregateName: null,
                thenName: null,

                canvasbase: null,
                //common
                namePanel: '',
                descriptionPanel: '',
                examplesPanel: '',

                // Event
                commandLists: [],
                //translate
                usedTranslate: false,
                translateText: '',

                //command
                restfulList: ['GET', 'POST', 'PATCH', 'DELETE', 'PUT'],
                //aggregate , event
                entityTypeList: ['Integer', 'String', 'Boolean', 'Float', 'Double', 'Long', 'Date'],

                //view
                attributeEdit: false,
                attributeEditIndex: 0,

                //attribute
                drag: false,
                entityKey: false,
                entityType: '',
                entityName: '',
                memberList: [],
                userTableHeaders: [
                    {
                        text: 'Name',
                        align: 'start',
                        sortable: false,
                        value: 'userName',
                    },
                    {
                        text: 'Readable',
                        value: 'readable',
                    },
                    {
                        text: 'Writable',
                        value: 'writable',
                    },
                    {
                        text: 'Admin',
                        value: 'admin',
                    }
                ],
                headers: [
                    {
                        text: 'key',
                        value: 'isKey',
                        align: 'center'
                    },
                    {
                        text: 'type',
                        value: 'className',
                        align: 'center'
                    },
                    {
                        text: 'name',
                        value: 'name',
                        align: 'center'
                    },
                    {
                        text: 'Actions',
                        value: 'action',
                        sortable: false,
                        align: 'center'
                    },],

                // UML Class
                classDiagram: false,
                classModels: null,
                aggregateRoots: [],

                givenItems: [],
                // whenItems: [],
                // thenItems: [],
                aggregateRules: [],
                ruleValues: {
                    ruleName: null,
                    whenItems: [],
                    thenItems: [],
                    givenValue: null,
                    whenValue: null,
                    thenValue: null,
                    show: false,
                    editMode: false,
                    attributes: []
                },
                ruleAttribute: {
                    givenAtt: {
                        attKey: [],
                        attValue: [],
                    },
                    aggregateAtt: {
                        attKey: [],
                        attValue: [],
                    },
                    thenAtt: {
                        attKey: [],
                        attValue: [],
                    },
                },
                AggregateRulePanelStatus: false,
                colorList: [ '#F1A746', '#5099F7', '#BB94BF', '#F8D454', '#ED73B6', '#5FC08B', '#8E24AA', '#000000', '#9E9E9E' ],
            }

        },
        watch: {
            "namePanel": _.debounce(function (newVal) {
                var me = this
                if (me.copyValue._type == 'org.uengine.modeling.model.Policy' || me.copyValue._type == 'org.uengine.modeling.model.Actor' || me.copyValue._type == 'org.uengine.modeling.model.Issue') {
                    me.copyValue.name = newVal
                } else {
                    me.copyValue.name = newVal.replace(/\n/g, "").replace(/ /gi, "")
                }
                me.getTranslate(me.copyValue.name)
                if (me.value.elementView)
                    me.canvasbase.$refs[`${me.value.elementView.id}`][0].namePanel = me.copyValue.name
                else if (me.value.relationView)
                    me.canvasbase.$refs[`${me.value.relationView.id}`][0].namePanel = me.copyValue.name
            }, 500),
            "descriptionPanel": _.debounce(function (newVal) {
                var me = this
                if (!me.copyValue.description) me.copyValue.description = ''
                me.copyValue.description = newVal
                me.canvasbase.$refs[`${me.value.elementView.id}`][0].descriptionPanel = me.copyValue.description
            }, 500),
            "examplesPanel": _.debounce(function (newVal) {
                var me = this
                if (!me.copyValue.examples) me.copyValue.examples = ''
                me.copyValue.examples = newVal
                me.canvasbase.$refs[`${me.value.elementView.id}`][0].examplesPanel = me.copyValue.examples
            }, 500),
        },
        methods: {
            onGridReady(params) {
                this.gridApi = params.api;
                this.gridColumnApi = params.columnApi;
            },
            onRowSelected(event){
                if(event.node.selected == true){
                    this.rowIndex = event.node.rowIndex
                }
                // this.gridApi.stopEditing();
                // console.log(this.rowIndex)
            },
            openExampleDialog(rule){
                var me = this

                me.rowIndex = null
                rule.show = true

                me.givenColumnDefs = [
                    { headerName: 'Given', children: []},
                ]
                me.thenColumnDefs = [
                    { headerName: 'Then', children: []},
                ]
                me.givenRowData = []
                me.thenRowData = []

                me.givenName = null
                me.aggregateName = null
                me.thenName = null

                for(var i = 0; i < rule.givenValue.fieldDescriptors.length; i++){
                    var childrenValue = {
                        headerName: rule.givenValue.name + "." + rule.givenValue.fieldDescriptors[i].name,
                        field: rule.givenValue.name + rule.givenValue.fieldDescriptors[i].name,
                    }
                    me.givenColumnDefs[0].children.push(childrenValue)

                    me.givenName = rule.givenValue.name
                }
                for(var i = 0; i < me.copyValue.aggregateRoot.fieldDescriptors.length; i++){
                    var childrenValue = {
                        headerName: me.copyValue.name + "." + me.copyValue.aggregateRoot.fieldDescriptors[i].name,
                        field: me.copyValue.name + me.copyValue.aggregateRoot.fieldDescriptors[i].name,
                    }
                    me.givenColumnDefs[0].children.push(childrenValue)

                    me.aggregateName = me.copyValue.name
                }
                if(rule.thenValue!=null){
                    for(var i = 0; i < rule.thenValue.fieldDescriptors.length; i++){
                        var childrenValue = {
                            headerName: rule.thenValue.name + "." + rule.thenValue.fieldDescriptors[i].name,
                            field: rule.thenValue.name + rule.thenValue.fieldDescriptors[i].name,
                        }
                        me.thenColumnDefs[0].children.push(childrenValue)
    
                        me.thenName = rule.thenValue.name
                    }
                }
                
                for(var att = 0; att < rule.attributes.length; att++){
                    var givenItem = {}
                    var thenItem = {}
                    // item['gridExamplefield'] = "ex " + (att + 1)
                    if(rule.attributes[att].givenAtt.attKey && rule.attributes[att].thenAtt.attKey && rule.attributes[att].aggregateAtt.attKey){
                        Object.keys(rule.attributes[att].givenAtt.attKey).forEach(function(data){
                            givenItem[me.givenName + rule.attributes[att].givenAtt.attKey[data]] = rule.attributes[att].givenAtt.attValue[data]
                        })
                        Object.keys(rule.attributes[att].aggregateAtt.attKey).forEach(function(data){
                            givenItem[me.aggregateName + rule.attributes[att].aggregateAtt.attKey[data]] = rule.attributes[att].aggregateAtt.attValue[data]
                        })
                        
                        Object.keys(rule.attributes[att].thenAtt.attKey).forEach(function(data){
                            thenItem[me.thenName + rule.attributes[att].thenAtt.attKey[data]] = rule.attributes[att].thenAtt.attValue[data]
                        })
                    
    
                    }
                    
    
                    me.givenRowData.push(givenItem)
                    me.thenRowData.push(thenItem)

                }
            },
            // addMembers() {
            //     var me = this;
            //     // if (!me.copyValue.members) {
            //     //     me.copyValue.members = []
            //     // }
            //     //
            //     // me.copyValue.members.push(me.member);
            //     // me.$emit('update:members', me.memberList);
            // },
            resetRules(rule){
                var me = this 
                rule.whenValue = null
                rule.thenValue = null
                rule.attributes = []

                var attribute = JSON.parse(JSON.stringify(me.ruleAttribute))
                rule.attributes.push(attribute)
            },
            changeAggregateRulePanelStatus(){
                var me = this
                console.log(me)
                var attachedPolicies = {} // agg에 붙어있는 폴리시들 
                if(Object.values(me.canvasbase.attachedLists.policyLists).length > 0){
                    Object.values(me.canvasbase.attachedLists.policyLists).forEach(function(policy, idx){
                        var outer = {
                            x: (policy.elementView.x - policy.elementView.width / 2) - 10,
                            y: (policy.elementView.y - policy.elementView.height / 2) - 10,
                            width: policy.elementView.width + 20,
                            height: policy.elementView.height + 20
                        }

                        var inner = {
                            x: me.copyValue.elementView.x - me.copyValue.elementView.width / 2,
                            y: me.copyValue.elementView.y - me.copyValue.elementView.height / 2,
                            width: me.copyValue.elementView.width,
                            height: me.copyValue.elementView.height
                        }

                        if (me.canvasbase._isAttached(outer, inner)) {
                            attachedPolicies[policy.elementView.id] = policy;
                        }
                    })
                }
                var incomingEvent = [] // 붙어 있는 폴리스들과 연결 되어 있는 외부 event 
                console.log(attachedPolicies)
                console.log(me.canvasbase.value.relations)
                if(Object.values(me.canvasbase.value.relations).length>0){
                    Object.values(me.canvasbase.value.relations).forEach(function(rel, idx){
                        if(rel != null){
                            if(rel.sourceElement._type == 'org.uengine.modeling.model.Event' && rel.targetElement._type == 'org.uengine.modeling.model.Policy'){
                                if(attachedPolicies[rel.targetElement.elementView.id]){
                                    incomingEvent.push(rel.sourceElement);
                                }
                            }
                        }
                    })
                }
                console.log(incomingEvent)
                me.givenItems = incomingEvent
                me.copyValue.givenItems = incomingEvent
                if(!me.copyValue.aggregateRules){
                    me.copyValue.aggregateRules = []
                    var values = JSON.parse(JSON.stringify(me.ruleValues))
                    var attribute = JSON.parse(JSON.stringify(me.ruleAttribute))
                    // me.aggregateRules.push(values)
                    me.copyValue.aggregateRules.push(values)
                    me.copyValue.aggregateRules[0].attributes.push(attribute)
                } else {
                    for(var i = 0; i < me.copyValue.aggregateRules.length; i++){
                        me.copyValue.aggregateRules[i].show = false
                        me.copyValue.aggregateRules[i].editMode = false
                    }
                }
                console.log(me.copyValue.aggregateRules)
                me.AggregateRulePanelStatus = !me.AggregateRulePanelStatus
            },
            chooseWhenPolicy(index){
                var chosenPolicy = []
                var me = this
                
                if(Object.values(me.canvasbase.value.relations).length > 0){
                    Object.values(me.canvasbase.value.relations).forEach(function(rel, idx){
                        if(rel != null){
                            if(rel.sourceElement._type == 'org.uengine.modeling.model.Event' && rel.targetElement._type == 'org.uengine.modeling.model.Policy'){
                                if(me.copyValue.aggregateRules[index].givenValue.elementView.id == rel.sourceElement.elementView.id){
                                    chosenPolicy.push(rel.targetElement)
                                }
                            }
                        }
                    })
                }
                // this.aggregateRules[index].whenItems = chosenPolicy
                this.copyValue.aggregateRules[index].whenItems = chosenPolicy
                console.log(this.copyValue.aggregateRules[index].whenItems)
            },
            chooseThenEvent(index){
                var chosenEvent = []
                var me = this
                
                if(Object.values(me.canvasbase.value.relations).length > 0){
                    Object.values(me.canvasbase.value.relations).forEach(function(rel, idx){
                        if(rel != null){
                            if(rel.sourceElement._type == 'org.uengine.modeling.model.Policy' && rel.targetElement._type == 'org.uengine.modeling.model.Event'){
                                if(me.copyValue.aggregateRules[index].whenValue.elementView.id == rel.sourceElement.elementView.id){
                                    chosenEvent.push(rel.targetElement)
                                }
                            }
                        }
                    })
                }
                
                // this.aggregateRules[index].thenItems = chosenEvent
                this.copyValue.aggregateRules[index].thenItems = chosenEvent
            },
            resetAttribute(rule, option){
                var me = this
                me.gridApi.stopEditing();                

                // console.log(me.givenRowData)
                // console.log(me.thenRowData)

                for(var i = 0; i < me.givenRowData.length; i++){
                    rule.attributes[i].givenAtt.attKey = []
                    rule.attributes[i].givenAtt.attValue = []

                    rule.attributes[i].aggregateAtt.attKey = []
                    rule.attributes[i].aggregateAtt.attValue = []

                    rule.attributes[i].thenAtt.attKey = []
                    rule.attributes[i].thenAtt.attValue = []

                    Object.keys(me.givenRowData[i]).forEach(function(data){
                        if(data.includes(me.givenName)){
                            rule.attributes[i].givenAtt.attKey.push(data.replace(me.givenName, ''))
                            rule.attributes[i].givenAtt.attValue.push(me.givenRowData[i][data])

                        }
                        if(data.includes(me.aggregateName)){
                            rule.attributes[i].aggregateAtt.attKey.push(data.replace(me.aggregateName, ''))
                            rule.attributes[i].aggregateAtt.attValue.push(me.givenRowData[i][data])
                        }
                    })

                    Object.keys(me.thenRowData[i]).forEach(function(data){
                        if(data.includes(me.thenName)){
                            rule.attributes[i].thenAtt.attKey.push(data.replace(me.thenName, ''))
                            rule.attributes[i].thenAtt.attValue.push(me.thenRowData[i][data])
                        }
                    })
                }
                if(option == 'add'){
                    var attribute = JSON.parse(JSON.stringify(me.ruleAttribute))
                    rule.attributes.push(attribute)
                } else if(option == 'delete'){
                    rule.attributes.splice(me.rowIndex, 1)
                } else if(option == 'save'){
                    rule.show = false
                    me.value.aggregateRules = me.copyValue.aggregateRules
                    console.log(me.value.aggregateRules)
                }

                if(option != 'save'){
                    me.openExampleDialog(rule)
                }
            },
            addAggregateRuleAttribute(rule){
                var me = this
                me.resetAttribute(rule, 'add');
            },
            deleteAggregateRuleAttribute(rule){
                var me = this
                me.resetAttribute(rule, 'delete');
            },
            addAggregateRule(){
                var me = this
                var values = JSON.parse(JSON.stringify(me.ruleValues))
                var attribute = JSON.parse(JSON.stringify(me.ruleAttribute))
                var idx = me.copyValue.aggregateRules.length

                // me.aggregateRules.push(values)
                me.copyValue.aggregateRules.push(values)
                me.copyValue.aggregateRules[idx].attributes.push(attribute) 
            },
            deleteAggregateRule(idx){
                var me = this
                me.copyValue.aggregateRules.splice(idx, 1)
            },
            // saveRules(){
            //     var me = this
            //     me.value.aggregateRules = me.copyValue.aggregateRules
            //     console.log(me.value.aggregateRules)
            //     // console.log(me.copyValue)
            // },
            findAssociatedAggregate() {
                var me = this

                me.copyValue.aggregate = {}
                if (Object.values(me.canvasbase.attachedLists.aggregateLists).length > 0) {

                    Object.values(me.canvasbase.attachedLists.aggregateLists).forEach(function (agg, index) {
                        var outer = {
                            x: (agg.elementView.x - agg.elementView.width / 2) - 10,
                            y: (agg.elementView.y - agg.elementView.height / 2) - 10,
                            width: agg.elementView.width + 20,
                            height: agg.elementView.height + 20
                        }

                        var inner = {
                            x: me.copyValue.elementView.x - me.copyValue.elementView.width / 2,
                            y: me.copyValue.elementView.y - me.copyValue.elementView.height / 2,
                            width: me.copyValue.elementView.width,
                            height: me.copyValue.elementView.height
                        }


                        if (me.canvasbase._isAttached(outer, inner)) {
                            me.copyValue.aggregate = agg;
                        }
                    })
                }
            },
            findCommandLists() {
                var me = this;
                me.commandLists = [];
                if (Object.values(me.canvasbase.attachedLists.commandLists).length > 0) {
                    Object.values(me.canvasbase.attachedLists.commandLists).forEach(function (command, index) {
                        if (command.boundedContext == me.copyValue.boundedContext) {
                            me.commandLists.push(command.name)
                        }
                    })
                }
            },
            // addTransformer: function () {
            //     this.transformers.push(
            //         {
            //             name: 'SUM',
            //             _type: 'org.uengine.kernel.transformers.SumTransformer',
            //             location: {x: 300, y: 200}
            //
            //         }
            //     )
            // },
            changeName: function () {
                this.editingTransformer.name = this.editingTransformer._type;
            },
            showProperty: function (transformer) {
                this.editingTransformer = transformer;
            },
            selectKey(item) {
                var me = this

                if (me.value._type == 'org.uengine.modeling.model.Aggregate') {
                    me.copyValue.aggregateRoot.fieldDescriptors.forEach(function (ele, idx) {
                        if (idx == me.copyValue.aggregateRoot.fieldDescriptors.indexOf(item)) {
                            ele.isKey = item.isKey
                        } else {
                            ele.isKey = false
                        }
                    })
                } else {
                    me.copyValue.fieldDescriptors.forEach(function (ele, idx) {
                        ele.isKey = false
                        // console.log(idx, me.value.fieldDescriptors.indexOf(item))
                        if (idx == me.copyValue.fieldDescriptors.indexOf(item)) {
                            ele.isKey = true
                        }
                    })

                }

            },
            isEmptyObject(obj) {
                var boolean = false
                if (obj == null) return true;
                if (Object.keys(obj) == 0) return true;

                Object.keys(obj).some(function (vari) {
                    if (!vari.includes('relation')) {
                        boolean = Object.keys(obj[vari]).length === 0 && obj.constructor === Object
                        return true
                    }

                })

                return boolean
            },
            viewMainRowAdd(type) {
                var me = this

                if (me.copyValue.dataProjection == 'cqrs') {


                    if (type == 'create') {

                        var obj = {
                            _type: 'viewStoreRule',
                            operation: 'CREATE',
                            when: null,
                            fieldMapping: [{"viewField": null, "eventField": null, 'operator': '='}],
                            where: [{"viewField": null, "eventField": null}],
                        }

                        me.copyValue.createRules.push(obj)
                    } else if (type == 'update') {
                        var obj = {
                            _type: 'viewStoreRule',
                            operation: 'UPDATE',
                            when: null,
                            fieldMapping: [{"viewField": null, "eventField": null, 'operator': '='}],
                            where: [{"viewField": null, "eventField": null}],
                        }
                        me.copyValue.updateRules.push(obj)
                    } else if (type == 'delete') {
                        var obj = {
                            _type: 'viewStoreRule',
                            operation: 'DELETE',
                            when: null,
                            fieldMapping: [{"viewField": null, "eventField": null}],
                            where: [{"viewField": null, "eventField": null}],
                        }
                        me.copyValue.deleteRules.push(obj)
                    }

                } else if (me.copyValue.dataProjection == 'uimashup') {
                    // var ob = {
                    //     isKey: false,
                    //     name: '',
                    //     className: '',
                    //     sourceRepository: '',
                    //     repositoryDirectValue: '',
                    //     hateoas: '',
                    //     link: ''
                    // }
                    // me.value.viewFieldDescriptors.push(ob);
                }
            },
            getTranslate:
                _.debounce(
                    function (newVal) {
                        var me = this
                        if (me.copyValue._type == 'org.uengine.modeling.model.Event') {
                            try {
                                googleTranslate.detectLanguage(newVal, function (err, detection) {
                                    if (detection.language != 'en') {
                                        googleTranslate.translate(newVal, 'en', function (err, translation) {
                                            me.usedTranslate = true
                                            me.translateText = changeCase.pascalCase(translation.translatedText);
                                        });
                                    }
                                });
                            } catch (e) {
                                // console.log('[Event ERROR]' + e)
                            }

                        } else if (me.copyValue._type == 'org.uengine.modeling.model.Policy') {

                            try {
                                googleTranslate.detectLanguage(newVal, function (err, detection) {
                                    if (detection.language != 'en') {
                                        googleTranslate.translate(newVal, 'en', function (err, translation) {
                                            me.usedTranslate = true
                                            me.translateText = changeCase.pascalCase(translation.translatedText);
                                        });
                                    } else if (detection.language == 'en') {
                                        me.usedTranslate = true
                                        me.translateText = changeCase.pascalCase(newVal)
                                    }
                                });
                            } catch (e) {
                                // console.log('[Policy ERROR]' + e)
                            }

                        } else if (me.copyValue._type == 'org.uengine.modeling.model.Aggregate') {

                            try {
                                googleTranslate.detectLanguage(newVal, function (err, detection) {
                                    if (detection.language != 'en') {
                                        googleTranslate.translate(newVal, 'en', function (err, translation) {
                                            me.usedTranslate = true
                                            me.translateText = changeCase.pascalCase(translation.translatedText);
                                        });
                                    } else if (detection.language == 'en') {
                                        me.usedTranslate = true
                                        me.translateText = changeCase.pascalCase(newVal)
                                    }
                                });
                            } catch (e) {
                                // console.log('[Aggregate ERROR]' + e)
                            }

                        } else if (me.copyValue._type != 'org.uengine.modeling.model.Issue') {
                            try {
                                googleTranslate.detectLanguage(newVal, function (err, detection) {
                                    if (detection.language != 'en') {
                                        googleTranslate.translate(newVal, 'en', function (err, translation) {
                                            me.usedTranslate = true
                                            me.translateText = translation.translatedText;
                                        });
                                    } else if (detection.language == 'en') {
                                        me.usedTranslate = true
                                        // me.translateText.replace(' ','')
                                    }
                                });
                            } catch (e) {
                                // console.log(e)
                            }
                        }
                    }, 500
                ),
            modifyAttributeItem(item) {
                var me = this
                var tmpObject = {
                    "_type": "org.uengine.model.FieldDescriptor",
                    "name": item.name,
                    "namePascalCase": changeCase.pascalCase(item.name),
                    "nameCamelCase": changeCase.camelCase(item.name),
                    "className": item.className,
                    "isKey": item.isKey,
                }

                if (me.copyValue._type == 'org.uengine.modeling.model.Aggregate') {
                    tmpObject['isName'] = item.isName
                    tmpObject['isList'] = item.isList
                    tmpObject['isVO'] = item.isVO
                    
                    if (tmpObject.isList) {
                        tmpObject.className = 'List<' + item.namePascalCase + '>'
                    } else if (!tmpObject.isList && !item.className.includes('List')) {
                        tmpObject.className = item.className
                    } else {
                        tmpObject.className = item.namePascalCase
                    }
                    me.copyValue.aggregateRoot.fieldDescriptors[me.attributeEditIndex] = tmpObject
                } else {
                    me.copyValue.fieldDescriptors[me.attributeEditIndex] = tmpObject
                }

                me.attributeEdit = false
            },
            editAttributeItem(item) {
                var me = this

                if (me.copyValue._type == 'org.uengine.modeling.model.Aggregate') {
                    if (item.className.includes('List')) {
                        // item.className = 'List'
                    }
                    me.attributeEditIndex = me.copyValue.aggregateRoot.fieldDescriptors.indexOf(item)
                } else {
                    me.attributeEditIndex = me.copyValue.fieldDescriptors.indexOf(item)
                }

                me.attributeEdit = true
            },
            deleteAttribute(val) {
                var me = this

                if (val.isKey) {
                    alert("Is Primary Key")
                } else {
                    if (me.copyValue._type == 'org.uengine.modeling.model.Aggregate') {
                        me.copyValue.aggregateRoot.fieldDescriptors.forEach(function (element, idx) {
                            if (!element.isKey && element.name == val.name && element.className == val.className) {

                                if (idx > -1)
                                    me.copyValue.aggregateRoot.fieldDescriptors.splice(idx, 1)

                                // me.$emit('update:aggregateRoot.fieldDescriptors', me.aggregateRoot.fieldDescriptors);
                            }
                        })
                    } else {

                        me.copyValue.fieldDescriptors.forEach(function (element, idx) {

                            if (element.name == val.name && element.className == val.className) {
                                if (idx > -1)
                                    me.copyValue.fieldDescriptors.splice(idx, 1)

                                // me.$emit('update:fieldDescriptors', me.fieldDescriptors);
                            }
                        })

                    }
                }

            },
            addAttribute: function (type, name) {
                var me = this
                if (type.length < 1) {
                    type = 'String'
                }
                if (type.length != 0 && name.length != 0) {
                    let tmpObject = null

                    tmpObject = {
                        "_type": "org.uengine.model.FieldDescriptor",
                        "name": name,
                        "namePascalCase": changeCase.pascalCase(name),
                        "nameCamelCase": changeCase.camelCase(name),
                        "className": type,
                        "isKey": false,
                    }

                    if (me.copyValue._type == "org.uengine.modeling.model.Aggregate") {
                        tmpObject['isName'] = false
                        tmpObject['isList'] = false
                        tmpObject['isVO'] = false

                        var check = false

                        if (((tmpObject.name).toLowerCase() == 'id' && (tmpObject.className).toLowerCase() == 'long')) {
                            check = true
                        } else {
                            me.copyValue.aggregateRoot.fieldDescriptors.forEach(function (agg) {
                                if ((JSON.stringify(Object.entries(agg).sort())).toLowerCase() == (JSON.stringify(Object.entries(tmpObject).sort())).toLowerCase()) {
                                    check = true
                                }
                            })
                            if (!check) {
                                me.copyValue.aggregateRoot.fieldDescriptors.push(tmpObject)
                            }
                        }

                    } else {
                        // me.value.fieldDescriptors.push(tmpObject);

                        var check = false


                        me.copyValue.fieldDescriptors.forEach(function (agg) {
                            if (JSON.stringify(Object.entries(agg).sort()).toLowerCase() === JSON.stringify(Object.entries(tmpObject).sort()).toLowerCase()) {
                                check = true
                            }
                        })

                        if (!check) {
                            me.copyValue.fieldDescriptors.push(tmpObject)
                        }


                    }

                    this.entityType = ""
                    this.entityName = ""

                } else {
                    // var designer = me.$parent.getComponent('event-storming-canvas')

                    me.canvasbase.text = "TYPE & NAME INPUT REQUEST"
                    me.canvasbase.snackbar = true
                }
            },

            changeTranslate() {
                this.namePanel = this.translateText
                this.usedTranslate = false
            },
            syncFromAggregate() {
                var me = this
                var aggregateField

                if (me.isEmptyObject(me.copyValue.aggregate)) {

                    alert("Attach 'Associated aggreate'")

                } else {
                    var aggLists = Object.values(me.canvasbase.attachedLists.aggregateLists)

                    if (aggLists.length > 0) {

                        var EventFields = JSON.parse(JSON.stringify(me.copyValue.fieldDescriptors))

                        var aggIndex = aggLists.findIndex(agg => agg.elementView.id == me.copyValue.aggregate.elementView.id)
                        if (aggIndex == -1) {
                            aggregateField = me.copyValue.aggregate.aggregateRoot.fieldDescriptors
                        } else {
                            aggregateField = aggLists[aggIndex].aggregateRoot.fieldDescriptors
                        }


                        if (aggregateField) {
                            aggregateField.forEach(function (aggField) {
                                var EventIndex = EventFields.findIndex(eventField => eventField.name == aggField.name && eventField.className == aggField.className)
                                if (EventIndex == -1) {
                                    aggField.isKey = false
                                    me.copyValue.fieldDescriptors.push(aggField)
                                }
                            })
                        }
                    }
                }
            },
            openClassDiagram() {
                var me = this
                if (me.copyValue.aggregateRoot.entities == undefined) {
                    me.copyValue.aggregateRoot['entities'] = {'elements': {}, 'relations': {}}
                }
                me.classModels = me.copyValue.aggregateRoot.entities
                me.aggregateRoots = []
                Object.values(me.canvasbase.value.elements).forEach(function (item) {
                    if (item) {
                        if (item._type == "org.uengine.modeling.model.Aggregate" && item.boundedContext == me.value.boundedContext) {
                            
                            if(item.elementView.id == me.copyValue.elementView.id) {
                                me.aggregateRoots.push(me.copyValue)
                                
                            } else {
                                me.aggregateRoots.push(item)
                                me.classModels = Object.assign(me.classModels, item.aggregateRoot.entities)

                            }
                        }
                    }
                })

                // if(localStorage.getItem('umlClass_'+me.copyValue.elementView.id)) {
                //     me.classModels = Object.assign(me.classModels, JSON.parse(localStorage.getItem('umlClass_'+me.copyValue.elementView.id)))
                // }

                localStorage['aggregateRoots'] = JSON.stringify(me.aggregateRoots)
                localStorage['umlClass_' + me.copyValue.elementView.id] = JSON.stringify(me.classModels);
                window.open("/#/uml-class/" + me.value.elementView.id, "_blank")
            },
            addAggregateRoot(entities) {
                var me = this

                if(entities) {
                    Object.keys(entities.elements).forEach(function (key) {
                        if(key && entities.elements[key] && entities.elements[key]._type != 'ClassGroup') {
                            if(entities.elements[key].parentId != me.copyValue.elementView.id) {
                                me.$EventBus.$emit(`${entities.elements[key].parentId}`, entities.elements[key])
                                me.$EventBus.$emit(`${entities.elements[key].parentId}`, { action: 'updateEntities', entities: entities })
                            } else {
                                me.copyValue.aggregateRoot.operations = entities.elements[key].operations
                                me.copyValue.aggregateRoot.fieldDescriptors = entities.elements[key].fieldDescriptors
                                me.copyValue.aggregateRoot.fieldDescriptors.forEach(function (attr) {
                                    attr['_type'] = "org.uengine.model.FieldDescriptor"
                                })
                            }
                        }
                    })
                }
                me.$nextTick(function() {
                    // localStorage.removeItem('umlClass_' + me.copyValue.elementView.id)
                    me.copyValue.aggregateRoot.entities = entities
                    me.setEntityTypeList()
                })
            },
            setEntityTypeList() {
                var me = this
                if (me.value.aggregateRoot.entities == undefined) {
                    return false
                }

                me.entityTypeList = [
                    {text: 'Primitive Types', disabled: true},
                    {text: 'Integer', value: 'Integer'},
                    {text: 'String', value: 'String'},
                    {text: 'Boolean', value: 'Boolean'},
                    {text: 'Float', value: 'Float'},
                    {text: 'Double', value: 'Double'},
                    {text: 'Long', value: 'Long'},
                    {text: 'Date', value: 'Date'},
                ]

                if (Object.values(me.value.aggregateRoot.entities.elements).length > 1) {
                    me.entityTypeList.push({text: 'Complex Types', disabled: true})
                    Object.values(me.value.aggregateRoot.entities.elements).forEach(function (item) {
                        if (item) {
                            if (item.name != me.copyValue.name) {
                                me.entityTypeList.push({text: item.name, value: item.name})
                            }
                        }
                    })
                }
            },

            changeColor(color) {
                var me = this;
                if(!me.canvasbase.isServerModeling) {
                    me.value.color = color
                }
                me.copyValue.color = color
            },
            resizedText(val) {
                var me = this;
                if(!me.canvasbase.isServerModeling) {
                    me.value.fontSize = val
                }
                me.copyValue.fontSize = val
            },
            resizedEdge(val) {
                var me = this;
                if(!me.canvasbase.isServerModeling) {
                    me.value.size = val
                }
                me.copyValue.size = val
            },
            changeDashStyle(val) {
                var me = this;
                if(!me.canvasbase.isServerModeling) {
                    me.value.dashStyle = val
                }
                me.copyValue.dashStyle = val
            },
        }
    }
</script>


<style lang="scss" rel="stylesheet/scss">
    .v-icon.outlined {
        border: 1px solid currentColor;
        border-radius: 0%;
    }

    .md-sidenav .md-sidenav-content {
        width: 400px;
    }

    .md-sidenav.md-right .md-sidenav-content {
        width: 600px;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }

    .no-move {
        transition: transform 0s;
    }

    .ghost {
        opacity: 0.5;
        background: #c8ebfb;
    }

    .list-group {
        min-height: 20px;
    }

    .list-group-item {
        cursor: move;
    }

    .list-group-item i {
        cursor: pointer;
    }

    #suggested-words:hover {
        background-color: #E3F2FD;
        cursor: pointer;
    }
</style>